import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function RionetlaagePage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/307856433-619479086206962-5755407830602206550-n.jpg", title: "Rionetlåge" },
    { src: "/_assets/rionet-19.jpeg", title: "Rionet detalje" },
    { src: "/_assets/smedl-ge2-1.jpeg", title: "Låge i rionet og stål" },
  ];

  return (
    <>
      <SEO
        title="Rionetlåger – fleksible løsninger til din ejendom | Hovendals"
        description="Rionetlåger med funktion og stil Rionetlåger er en populær løsning for mange husejere, der ønsker at sikre deres ejendom, samtidig med at de tilføjer et æstetisk tiltalende låge til deres hjem. Hovendals, en virksomhed der tilbyder rionetlåger, der kombinerer funktionalitet med stil og samtidig kan vi også tilbyde dig et hav af muligheder, når det kommer til rionethegn. Tøv ikke med at kontakte os allerede i dag"
        ogImage="/_assets/480188274-1283354403152757-3860986236524628895-n-0.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/480188274-1283354403152757-3860986236524628895-n-0.jpg", "width=1600,quality=80,format=auto")}
            alt="Rionetlåger"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-grid-2" aria-hidden="true"></i>
              <span>Fleksibel & stilren</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Rionetlåger – fleksible løsninger til din ejendom
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Rionetlåger er en populær løsning for mange husejere, der ønsker at sikre deres ejendom, samtidig med at de tilføjer en æstetisk tiltalende låge til deres hjem.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Funktion og stil</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Rionetlåger med funktion og stil
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Rionetlåger er en populær løsning for mange husejere, der ønsker at sikre deres ejendom, samtidig med at de tilføjer et æstetisk tiltalende låge til deres hjem. Hovendals, en virksomhed der tilbyder rionetlåger, der kombinerer funktionalitet med stil og samtidig kan vi også tilbyde dig et hav af muligheder, når det kommer til rionethegn.
              </p>
              <p className="text-slate-700 leading-relaxed text-base font-semibold">
                Tøv ikke med at kontakte os allerede i dag
              </p>

              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  Hvorfor vælge en rionetlåge?
                </h3>
                <p className="text-slate-700 leading-relaxed text-base mb-3">
                  En rionetlåge er lavet af et kraftigt, svejset net af ståltråd, som er både holdbart og modstandsdygtigt over for vejrpåvirkninger. Dette gør dem ideelle til udendørs brug, hvor de kan stå imod alt fra kraftig vind til kraftig regn uden at ruste eller forringe i kvalitet.
                </p>
                <p className="text-slate-700 leading-relaxed text-base mb-3">
                  Hos Hovendals er der fokus på kvalitet og kundetilfredshed, og deres rionetlåger er ingen undtagelse. Lågerne kan tilpasses i størrelse og design for at passe til enhver indgang eller have.
                </p>
                <p className="text-slate-700 leading-relaxed text-base">
                  Investering i en rionetlåge fra Hovendals er også en økonomisk smart beslutning. På grund af deres holdbarhed kræver disse låger minimal vedligeholdelse, hvilket sparer dig tid og penge i det lange løb. Desuden kan tilføjelsen af en sikker låge også øge din ejendoms værdi. Samlet set er en rionetlåge fra Hovendals en fremragende tilføjelse til enhver ejendom, der ønsker at kombinere sikkerhed med stil.
                </p>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få et uforpligtende tilbud</span>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/307856433-619479086206962-5755407830602206550-n.jpg", "width=800,quality=85,format=auto")}
                alt="Rionetlåge"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Galleri */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Billeder af rionetlåger
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Klik på et billede for at se forstørret version.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-48 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=600,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2.5 rounded-full bg-[#143463]/90 text-white text-sm">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Kontaktinfo */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-10 border border-slate-200/80 space-y-4">
            <h3 className="text-2xl font-bold text-slate-900">
              Kontakt os og få et uforpligtende tilbud på rionetlåger
            </h3>
            <p className="text-slate-700 leading-relaxed text-base">
              Ønsker du at få et uforpligtende tilbud på en rionetlåge? Så er du velkommen til at kontakte os på <a href={`tel:${companyInfo.phoneFormatted}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.phone}</a> eller send os en mail på <a href={`mailto:${companyInfo.email}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.email}</a> også vender vi tilbage til dig hurtigst muligt.
            </p>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
